/**
 * Lightweight haptic feedback. No-ops where the Vibration API is unsupported
 * (iOS Safari doesn't support it, but Android PWAs do).
 */
export function haptic(pattern: number | number[] = 8): void {
  try {
    if (typeof navigator !== "undefined" && "vibrate" in navigator) {
      navigator.vibrate(pattern);
    }
  } catch {
    /* ignore */
  }
}
